import { CustomAlert } from "components";
import { useEffect } from "react";
import toast from "react-hot-toast";

const useResponseErrorOnly = (response) => {
  useEffect(() => {
    if (response.error) {
      toast.custom((t) => (
        <CustomAlert
          t={t}
          type="error"
          data={`Bir hata oluştu ${response.error.data.message ?? ""}`}
        />
      ));
    }
  }, [response.isError, response.error]);
};

export default useResponseErrorOnly;
